
      // Dynamic manifest based on current route
      function updateManifest() {
        const manifestLink = document.querySelector('link[rel="manifest"]');
        const currentPath = window.location.pathname;
        const currentHash = window.location.hash;
        
        console.log('Current path:', currentPath, 'Hash:', currentHash);
        
        if (currentPath.includes('maintenance') || currentHash.includes('maintenance')) {
          console.log('Generating MaintTech manifest');
          
          const maintenanceManifest = {
            "name": "MaintTech Pro - Maintenance Team",
            "short_name": "MaintTech",
            "description": "Your maintenance command center — manage work orders, track inventory, and coordinate repairs on the go",
            "start_url": "/maintenance-auth",
            "display": "standalone",
            "background_color": "#000000",
            "theme_color": "#2563eb",
            "orientation": "portrait-primary",
            "scope": "/",
            "lang": "en",
            "categories": ["productivity", "utilities", "business"],
            "icons": [
              {
                "src": "/icons/maintenance/icon-48x48.png",
                "sizes": "48x48",
                "type": "image/png",
                "purpose": "maskable any"
              },
              {
                "src": "/icons/maintenance/icon-72x72.png",
                "sizes": "72x72",
                "type": "image/png",
                "purpose": "maskable any"
              },
              {
                "src": "/icons/maintenance/icon-96x96.png",
                "sizes": "96x96",
                "type": "image/png",
                "purpose": "maskable any"
              },
              {
                "src": "/icons/maintenance/icon-120x120.png",
                "sizes": "120x120",
                "type": "image/png",
                "purpose": "maskable any"
              },
              {
                "src": "/icons/maintenance/icon-144x144.png",
                "sizes": "144x144",
                "type": "image/png",
                "purpose": "maskable any"
              },
              {
                "src": "/icons/maintenance/icon-152x152.png",
                "sizes": "152x152",
                "type": "image/png",
                "purpose": "maskable any"
              },
              {
                "src": "/icons/maintenance/icon-167x167.png",
                "sizes": "167x167",
                "type": "image/png",
                "purpose": "maskable any"
              },
              {
                "src": "/icons/maintenance/icon-180x180.png",
                "sizes": "180x180",
                "type": "image/png",
                "purpose": "maskable any"
              },
              {
                "src": "/icons/maintenance/icon-192x192.png",
                "sizes": "192x192",
                "type": "image/png",
                "purpose": "maskable any"
              },
              {
                "src": "/icons/maintenance/icon-512x512.png",
                "sizes": "512x512",
                "type": "image/png",
                "purpose": "maskable any"
              },
              {
                "src": "/icons/maintenance/icon-1024x1024.png",
                "sizes": "1024x1024",
                "type": "image/png",
                "purpose": "maskable any"
              }
            ],
            "shortcuts": [
              {
                "name": "Work Orders",
                "short_name": "Orders",
                "description": "View and manage work orders",
                "url": "/maintenance-team?tab=orders",
                "icons": [
                  {
                    "src": "/icons/maintenance/icon-192x192.png",
                    "sizes": "96x96"
                  }
                ]
              },
              {
                "name": "Inventory",
                "short_name": "Inventory",
                "description": "Check parts and inventory",
                "url": "/maintenance-team?tab=inventory",
                "icons": [
                  {
                    "src": "/icons/maintenance/icon-192x192.png",
                    "sizes": "96x96"
                  }
                ]
              }
            ]
          };
          
          // Update page meta tags for MaintTech
          document.title = "MaintTech Pro - Maintenance Team";
          document.querySelector('meta[name="description"]').setAttribute('content', 'Your maintenance command center — manage work orders, track inventory, and coordinate repairs on the go');
          document.querySelector('meta[name="theme-color"]').setAttribute('content', '#2563eb');
          document.querySelector('meta[name="application-name"]').setAttribute('content', 'MaintTech Pro');
          document.querySelector('meta[name="apple-mobile-web-app-title"]').setAttribute('content', 'MaintTech');
          
          // Swap favicons to maintenance icons
          document.querySelectorAll('link[rel="icon"]').forEach(function(link) {
            var size = link.getAttribute('sizes');
            if (size === '32x32') link.href = '/icons/maintenance/icon-48x48.png';
            else if (size === '16x16') link.href = '/icons/maintenance/icon-48x48.png';
            else link.href = '/icons/maintenance/icon-48x48.png';
          });
          
          // Add Apple touch icons for MaintTech
          const existingAppleTouchIcons = document.querySelectorAll('link[rel="apple-touch-icon"]');
          existingAppleTouchIcons.forEach(link => link.remove());
          const maintAppleSizes = [
            { sizes: '180x180', href: '/icons/maintenance/icon-180x180.png' },
            { sizes: '152x152', href: '/icons/maintenance/icon-152x152.png' },
            { sizes: '120x120', href: '/icons/maintenance/icon-120x120.png' },
            { sizes: '167x167', href: '/icons/maintenance/icon-167x167.png' }
          ];
          maintAppleSizes.forEach(({ sizes, href }) => {
            const link = document.createElement('link');
            link.rel = 'apple-touch-icon';
            link.sizes = sizes;
            link.href = href;
            document.head.appendChild(link);
          });
          
          const blob = new Blob([JSON.stringify(maintenanceManifest)], { type: 'application/json' });
          const manifestUrl = URL.createObjectURL(blob);
          manifestLink.href = manifestUrl;
          console.log('MaintTech manifest updated:', manifestUrl);
          
        } else if (currentPath.includes('vendor-tech') || currentHash.includes('vendor-tech')) {
          console.log('Generating VendorLynx manifest');
          
          const vendorManifest = {
            "name": "VendorLynx Pro - Field Tech",
            "short_name": "VendorLynx",
            "description": "Dispatch jobs, clock in/out, and complete field service work orders from anywhere",
            "start_url": "/vendor-auth",
            "display": "standalone",
            "background_color": "#000000",
            "theme_color": "#dc2626",
            "orientation": "portrait-primary",
            "scope": "/",
            "lang": "en",
            "categories": ["productivity", "utilities", "business"],
            "icons": [
              {
                "src": "/icons/vendor/icon-48x48.png",
                "sizes": "48x48",
                "type": "image/png",
                "purpose": "maskable any"
              },
              {
                "src": "/icons/vendor/icon-72x72.png",
                "sizes": "72x72",
                "type": "image/png",
                "purpose": "maskable any"
              },
              {
                "src": "/icons/vendor/icon-96x96.png",
                "sizes": "96x96",
                "type": "image/png",
                "purpose": "maskable any"
              },
              {
                "src": "/icons/vendor/icon-120x120.png",
                "sizes": "120x120",
                "type": "image/png",
                "purpose": "maskable any"
              },
              {
                "src": "/icons/vendor/icon-144x144.png",
                "sizes": "144x144",
                "type": "image/png",
                "purpose": "maskable any"
              },
              {
                "src": "/icons/vendor/icon-152x152.png",
                "sizes": "152x152",
                "type": "image/png",
                "purpose": "maskable any"
              },
              {
                "src": "/icons/vendor/icon-167x167.png",
                "sizes": "167x167",
                "type": "image/png",
                "purpose": "maskable any"
              },
              {
                "src": "/icons/vendor/icon-180x180.png",
                "sizes": "180x180",
                "type": "image/png",
                "purpose": "maskable any"
              },
              {
                "src": "/icons/vendor/icon-192x192.png",
                "sizes": "192x192",
                "type": "image/png",
                "purpose": "maskable any"
              },
              {
                "src": "/icons/vendor/icon-512x512.png",
                "sizes": "512x512",
                "type": "image/png",
                "purpose": "maskable any"
              }
            ],
            "shortcuts": [
              {
                "name": "Emergency Jobs",
                "short_name": "Emergency",
                "description": "View emergency job alerts",
                "url": "/vendor-tech?tab=jobs&filter=urgent",
                "icons": [
                  {
                    "src": "/icons/vendor/icon-192x192.png",
                    "sizes": "96x96"
                  }
                ]
              },
              {
                "name": "Time Clock",
                "short_name": "Clock",
                "description": "Clock in/out and manage time",
                "url": "/vendor-tech?tab=dashboard&action=timeclock",
                "icons": [
                  {
                    "src": "/icons/vendor/icon-192x192.png",
                    "sizes": "96x96"
                  }
                ]
              }
            ]
          };
          
          // Update page meta tags for VendorLynx
          document.title = "VendorLynx Pro - Field Tech App";
          document.querySelector('meta[name="description"]').setAttribute('content', 'Dispatch jobs, clock in/out, and complete field service work orders from anywhere');
          document.querySelector('meta[name="theme-color"]').setAttribute('content', '#dc2626');
          document.querySelector('meta[name="application-name"]').setAttribute('content', 'VendorLynx Pro');
          document.querySelector('meta[name="apple-mobile-web-app-title"]').setAttribute('content', 'VendorLynx');
          
          const blob = new Blob([JSON.stringify(vendorManifest)], { type: 'application/json' });
          const manifestUrl = URL.createObjectURL(blob);
          manifestLink.href = manifestUrl;
          console.log('VendorLynx manifest updated:', manifestUrl);
          
        } else if (currentPath.includes('tenant') || currentHash.includes('tenant')) {
          console.log('Generating Tenant manifest');
          
          const tenantManifest = {
            "name": "TenantShield Pro",
            "short_name": "TenantShield",
            "description": "Submit maintenance requests, track repairs, and stay connected with your property team",
            "start_url": "/tenant-auth",
            "display": "standalone",
            "background_color": "#1f2937",
            "theme_color": "#4f46e5",
            "orientation": "portrait-primary",
            "scope": "/",
            "lang": "en",
            "categories": ["lifestyle", "utilities"],
            "icons": [
              { "src": "/icons/tenant/icon-48x48.png", "sizes": "48x48", "type": "image/png", "purpose": "any" },
              { "src": "/icons/tenant/icon-72x72.png", "sizes": "72x72", "type": "image/png", "purpose": "any" },
              { "src": "/icons/tenant/icon-96x96.png", "sizes": "96x96", "type": "image/png", "purpose": "any" },
              { "src": "/icons/tenant/icon-120x120.png", "sizes": "120x120", "type": "image/png", "purpose": "any" },
              { "src": "/icons/tenant/icon-144x144.png", "sizes": "144x144", "type": "image/png", "purpose": "any" },
              { "src": "/icons/tenant/icon-152x152.png", "sizes": "152x152", "type": "image/png", "purpose": "any" },
              { "src": "/icons/tenant/icon-167x167.png", "sizes": "167x167", "type": "image/png", "purpose": "any" },
              { "src": "/icons/tenant/icon-180x180.png", "sizes": "180x180", "type": "image/png", "purpose": "any" },
              { "src": "/icons/tenant/icon-192x192.png", "sizes": "192x192", "type": "image/png", "purpose": "any" },
              { "src": "/icons/tenant/icon-384x384.png", "sizes": "384x384", "type": "image/png", "purpose": "any" },
              { "src": "/icons/tenant/icon-512x512.png", "sizes": "512x512", "type": "image/png", "purpose": "any" },
              { "src": "/icons/tenant/icon-512x512-maskable.png", "sizes": "512x512", "type": "image/png", "purpose": "maskable" }
            ],
            "shortcuts": [
              {
                "name": "Submit Request",
                "short_name": "Request",
                "description": "Submit a maintenance request",
                "url": "/tenant?tab=requests",
                "icons": [{ "src": "/icons/tenant/icon-96x96.png", "sizes": "96x96" }]
              },
              {
                "name": "Messages",
                "short_name": "Messages",
                "description": "View property messages",
                "url": "/tenant?tab=communication",
                "icons": [{ "src": "/icons/tenant/icon-96x96.png", "sizes": "96x96" }]
              }
            ]
          };
          
          // Update page meta tags for Tenant
          document.title = "TenantShield Pro - Resident Portal";
          document.querySelector('meta[name="description"]').setAttribute('content', 'Submit maintenance requests, track repairs, and stay connected with your property team');
          document.querySelector('meta[name="theme-color"]').setAttribute('content', '#4f46e5');
          document.querySelector('meta[name="application-name"]').setAttribute('content', 'TenantShield Pro');
          document.querySelector('meta[name="apple-mobile-web-app-title"]').setAttribute('content', 'TenantShield');
          
          // Swap apple-touch-icon links to tenant icons
          document.querySelectorAll('link[rel="apple-touch-icon"]').forEach(function(link) {
            var size = link.getAttribute('sizes');
            if (size) {
              link.href = '/icons/tenant/icon-' + size + '.png';
            } else {
              link.href = '/icons/tenant/icon-180x180.png';
            }
          });
          // Swap favicons
          document.querySelectorAll('link[rel="icon"]').forEach(function(link) {
            var size = link.getAttribute('sizes');
            if (size === '32x32') link.href = '/icons/tenant/icon-32x32.png';
            else if (size === '16x16') link.href = '/icons/tenant/icon-16x16.png';
            else link.href = '/icons/tenant/icon-32x32.png';
          });
          
          const blob = new Blob([JSON.stringify(tenantManifest)], { type: 'application/json' });
          const manifestUrl = URL.createObjectURL(blob);
          manifestLink.href = manifestUrl;
          console.log('Tenant manifest updated:', manifestUrl);
          
        } else {
          console.log('Using default PropertyShield manifest');
          // Reset to default manifest
          manifestLink.href = '/manifest.json';
          document.title = "PropertyShield AI - Unified Platform";
          document.querySelector('meta[name="description"]').setAttribute('content', 'Revolutionary property management and field service platform');
          document.querySelector('meta[name="theme-color"]').setAttribute('content', '#dc2626');
          document.querySelector('meta[name="application-name"]').setAttribute('content', 'PropertyShield AI');
          document.querySelector('meta[name="apple-mobile-web-app-title"]').setAttribute('content', 'PropertyShield');
        }
      }
      
      // Update manifest on page load and route change
      updateManifest();
      
      // Listen for route changes (for SPA navigation)
      window.addEventListener('popstate', updateManifest);
      
      // Override pushState and replaceState to catch programmatic navigation
      const originalPushState = history.pushState;
      const originalReplaceState = history.replaceState;
      
      history.pushState = function() {
        originalPushState.apply(history, arguments);
        setTimeout(updateManifest, 0);
      };
      
      history.replaceState = function() {
        originalReplaceState.apply(history, arguments);
        setTimeout(updateManifest, 0);
      };
    
      // Service worker registration handled by Vite PWA in production only.
      // Removed custom registration to avoid duplicate SWs and update loops.

      // PWA Install Prompt - handles both iOS and Android
      let deferredPrompt;
      
      // Detect iOS Safari
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
      const isSafari = /Safari/.test(navigator.userAgent) && !/CriOS|FxiOS|OPiOS|EdgiOS/.test(navigator.userAgent);
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches || 
                          window.navigator.standalone === true;
      
      // For iOS Safari: Show instructions banner
      function showIOSInstallBanner() {
        const currentPath = window.location.pathname;
        if (!currentPath.includes('vendor-tech') && !currentPath.includes('maintenance-team') && !currentPath.includes('tenant-auth') && !currentPath.includes('tenant')) return;
        
        const lastDismissed = localStorage.getItem('ios-pwa-install-dismissed');
        const dismissedRecently = lastDismissed && (Date.now() - parseInt(lastDismissed)) < 7 * 24 * 60 * 60 * 1000;
        
        if (dismissedRecently || isStandalone) return;
        
        // Banner will be handled by React components now
        console.log('iOS Safari detected - PWA install guidance available via React components');
      }
      
      // Check for iOS on load
      if (isIOS && isSafari) {
        setTimeout(showIOSInstallBanner, 2000);
      }
      
      window.addEventListener('beforeinstallprompt', (e) => {
        console.log('PWA install prompt triggered (Android/Chrome)');
        e.preventDefault();
        deferredPrompt = e;
        
        // Show custom install banner for vendor tech, maintenance team, and tenant apps
        const currentPath = window.location.pathname;
        if (currentPath.includes('vendor-tech') || currentPath.includes('maintenance-team') || currentPath.includes('tenant-auth') || currentPath.includes('tenant')) {
          const banner = document.getElementById('pwa-install-banner');
          const bannerTitle = document.getElementById('pwa-banner-title');
          const bannerDesc = document.getElementById('pwa-banner-desc');
          
          if (currentPath.includes('maintenance-team')) {
            if (bannerTitle) bannerTitle.textContent = 'Install MaintTech Pro';
            if (bannerDesc) bannerDesc.textContent = 'Get the full maintenance team experience with offline access';
          } else if (currentPath.includes('vendor-tech')) {
            if (bannerTitle) bannerTitle.textContent = 'Install VendorLynx Pro';
            if (bannerDesc) bannerDesc.textContent = 'Get the full field tech experience with offline access';
          } else if (currentPath.includes('tenant')) {
            if (bannerTitle) bannerTitle.textContent = 'Install TenantShield Pro';
            if (bannerDesc) bannerDesc.textContent = 'Get the full resident experience — requests, messages & more';
          }
          
          if (banner) banner.style.display = 'block';
        }
      });

      // Handle install button click
      document.addEventListener('DOMContentLoaded', () => {
        const installButton = document.getElementById('pwa-install-button');
        const dismissButton = document.getElementById('pwa-dismiss-button');
        const banner = document.getElementById('pwa-install-banner');

        if (installButton) {
          installButton.addEventListener('click', async () => {
            if (deferredPrompt) {
              deferredPrompt.prompt();
              const { outcome } = await deferredPrompt.userChoice;
              console.log(`PWA install outcome: ${outcome}`);
              deferredPrompt = null;
            }
            if (banner) banner.style.display = 'none';
          });
        }

        if (dismissButton) {
          dismissButton.addEventListener('click', () => {
            if (banner) banner.style.display = 'none';
            localStorage.setItem('pwa-install-dismissed', 'true');
          });
        }

        // Don't show banner if previously dismissed
        if (localStorage.getItem('pwa-install-dismissed') === 'true') {
          if (banner) banner.style.display = 'none';
        }
      });

      // Handle app install
      window.addEventListener('appinstalled', (evt) => {
        console.log('PWA was installed');
        const banner = document.getElementById('pwa-install-banner');
        if (banner) banner.style.display = 'none';
      });
    